export const HOTEL = {
  name: "The Rayan",
  tagline: "A Sanctuary of Kashmiri Craftsmanship",
  phoneDisplay: "+91 96228 82111",
  phoneLink: "tel:+919622882111",
  whatsapp: "https://wa.me/919622882111",
  address: "Hyderpora Bypass, Srinagar, Jammu & Kashmir 190014",
  email: "info.hotelgrandrayan@gmail.com",
  mapEmbed: "https://www.google.com/maps?q=The+Rayan+Hotel,+Hyderpora+Bypass,+Srinagar,+Jammu+and+Kashmir+190014&output=embed",
  mapsLink: "https://www.google.com/maps/search/?api=1&query=The+Rayan+Hotel,+Hyderpora+Bypass,+Srinagar,+Jammu+and+Kashmir+190014",
};

export const IMG = {
  lobby: "https://customer-assets-cm19k8pv.emergentagent.net/job_a25de1db-13c2-4378-9cc9-a1ed7d25fbba/artifacts/3e34eb2e712659bf_IMG-20261009-WA0011.jpg",
  bedroom: "https://customer-assets-cm19k8pv.emergentagent.net/job_a25de1db-13c2-4378-9cc9-a1ed7d25fbba/artifacts/c7cc47d91906409a_IMG-20261009-WA0007.jpg",
  reception: "https://customer-assets-cm19k8pv.emergentagent.net/job_a25de1db-13c2-4378-9cc9-a1ed7d25fbba/artifacts/f8ae68a4e1e1dc4e_IMG-20261009-WA0009.jpg",
  bathroom: "https://customer-assets-cm19k8pv.emergentagent.net/job_a25de1db-13c2-4378-9cc9-a1ed7d25fbba/artifacts/c41b5dd1ad0c8d50_IMG-20261009-WA0010.jpg",
  lounge: "https://customer-assets-cm19k8pv.emergentagent.net/job_a25de1db-13c2-4378-9cc9-a1ed7d25fbba/artifacts/96ddc6e1a3f8e079_IMG-20261009-WA0013.jpg",
  dalLake: "https://images.unsplash.com/photo-1695667937079-b59c63660cfc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxzcmluYWdhciUyMGRhbCUyMGxha2UlMjBrYXNobWlyJTIwbHV4dXJ5JTIwbmF0dXJlJTIwbGFuZHNjYXBlfGVufDB8fHx8MTc5MTUxNjU5N3ww&ixlib=rb-4.1.0&q=85",
  shikara: "https://images.unsplash.com/photo-1614056965546-42fbe24eb36c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxzcmluYWdhciUyMGRhbCUyMGxha2UlMjBrYXNobWlyJTIwbHV4dXJ5JTIwbmF0dXJlJTIwbGFuZHNjYXBlfGVufDB8fHx8MTc5MTUxNjU5N3ww&ixlib=rb-4.1.0&q=85",
};

export const ROOMS = [
  {
    id: "deluxe",
    name: "Deluxe Walnut Room",
    price: 6500,
    size: "320 sq ft",
    bed: "King Bed",
    guests: 2,
    view: "Courtyard View",
    image: IMG.bedroom,
    blurb: "Hand-carved Kashmiri walnut panelling, warm cove lighting and a plush king bed dressed in crisp linen.",
    perks: ["Rain Shower", '43" Smart TV', "Kahwa Welcome Tray", "High-Speed Wi-Fi"],
  },
  {
    id: "premium",
    name: "Premium Walnut Room",
    price: 9500,
    size: "420 sq ft",
    bed: "King Bed + Lounge",
    guests: 3,
    view: "Boulevard View",
    image: IMG.lounge,
    blurb: "A private lounge nook, in-room tea atelier and floor-to-ceiling walnut wardrobe crafted by local artisans.",
    perks: ["Private Lounge Nook", "Marble Bath", '55" Smart TV', "Artisanal Breakfast"],
  },
  {
    id: "suite",
    name: "Royal Executive Suite",
    price: 14500,
    size: "640 sq ft",
    bed: "King + Living Room",
    guests: 4,
    view: "Panoramic View",
    image: IMG.bedroom,
    image2: IMG.bathroom,
    blurb: "Our signature suite — a separate living room, backlit marble bath and butler service, day and night.",
    perks: ["Separate Living Room", "Butler Service", "Backlit Marble Bath", "Airport Transfers"],
  },
];

export const AMENITIES = [
  { icon: "BellRing", title: "24/7 Butler Service", text: "A dedicated host for every guest, around the clock." },
  { icon: "Coffee", title: "Kashmiri Kahwa Lounge", text: "Saffron kahwa and noon chai served all day." },
  { icon: "Car", title: "Airport Pick & Drop", text: "Chauffeured transfers, 10 minutes from Srinagar Airport." },
  { icon: "Wifi", title: "High-Speed Wi-Fi", text: "Fibre connectivity in every room and lounge." },
  { icon: "Heater", title: "Central Heating", text: "Warm winters, Kashmiri hamam-style comfort." },
  { icon: "MountainSnow", title: "Mountain Views", text: "Balconies framing the Zabarwan foothills." },
  { icon: "UtensilsCrossed", title: "Artisanal Breakfast", text: "Girda, lavasa and wazwan-inspired mornings." },
  { icon: "ShieldCheck", title: "24/7 Security", text: "CCTV, secure parking and front-desk concierge." },
];

export const ATTRACTIONS = [
  { name: "Dal Lake", time: "15 min drive", image: IMG.dalLake, text: "Shikara rides at golden hour over mirror-still water." },
  { name: "Shikara Ride", time: "15 min drive", image: IMG.shikara, text: "Glide past floating gardens and houseboat boulevards." },
  { name: "Mughal Gardens", time: "25 min drive", text: "Nishat, Shalimar and Chashme Shahi terraces." },
  { name: "Hazratbal Shrine", time: "20 min drive", text: "The white marble shrine on the lake's northern shore." },
  { name: "Srinagar Airport", time: "10 min drive", text: "The closest luxury stay to Sheikh ul-Alam Airport." },
  { name: "Gulmarg Day Trip", time: "90 min drive", text: "Meadows, gondola rides and winter powder." },
];

export const TESTIMONIALS = [
  {
    name: "Aarav Mehta",
    city: "Mumbai",
    rating: 5,
    quote: "The walnut ceilings alone are worth the stay. Staff arranged a shikara at sunset within the hour — effortless luxury.",
  },
  {
    name: "Sara & Tom Whitfield",
    city: "London",
    rating: 5,
    quote: "Ten minutes from the airport yet utterly serene. The marble bathroom and kahwa on arrival set the tone for Kashmir.",
  },
  {
    name: "Ruqaiya Bhat",
    city: "Jammu",
    rating: 5,
    quote: "Immaculate rooms, heated floors in winter and the warmest front desk in Srinagar. Our family returns every season.",
  },
];

export const NAV_LINKS = [
  { label: "Rooms", href: "#rooms" },
  { label: "Gallery", href: "#gallery" },
  { label: "Amenities", href: "#amenities" },
  { label: "Explore", href: "#explore" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export function formatApiErrorDetail(detail) {
  if (detail == null) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function inr(n) {
  return "₹" + n.toLocaleString("en-IN");
}
